var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-fade-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLeft,
      expression: "showLeft"
    }],
    style: _vm.chevron(false),
    attrs: {
      "fab": "",
      "small": "",
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.scroll(false);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1)], 1), _c('v-fade-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRight,
      expression: "showRight"
    }],
    style: _vm.chevron(true),
    attrs: {
      "fab": "",
      "small": "",
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.scroll(true);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1), _c('div', {
    ref: "scroller",
    staticClass: "d-flex flex-row scroll-x",
    class: _vm.scrollClass,
    on: {
      "scroll": _vm.onScroll
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }